export var BI_UOU_ENDPOINT = 'blog-app-uou';
export var BI_UOU_SRC = 69;
